/**
 * Metric trace helpers for the dev-mode diagnostics layer.
 *
 * A "trace" travels alongside each dashboard metric and records: which data
 * source actually produced the number (and why), the formula with the real
 * inputs substituted, the raw inputs themselves, and any parse/fetch warnings.
 * Traces are plain data built from values the hooks already hold — creating
 * them adds no API calls; they are only rendered when dev mode is on.
 */

/** Thousands-separated number for formula strings. */
export const fmtN = (v) => {
  if (v == null || Number.isNaN(Number(v))) return '—';
  const n = Number(v);
  return Number.isInteger(n) ? n.toLocaleString() : n.toLocaleString(undefined, { maximumFractionDigits: 2 });
};

/**
 * Build a metric trace.
 * @param {string} metricKey
 * @param {{ source: string, sourceReason: string, formula?: string|null, inputs?: Object|null, warnings?: string[], fallbackChain?: Array<{source:string,used:boolean,reason:string}>|null }} spec
 */
export const makeTrace = (metricKey, { source, sourceReason, formula = null, inputs = null, warnings = [], fallbackChain = null }) => ({
  metricKey,
  source,
  sourceReason,
  formula,
  inputs,
  warnings: warnings.filter(Boolean),
  fallbackChain,
  computedAt: new Date().toISOString()
});

/**
 * Record one entry of the hook-level fetch log from a Promise.allSettled
 * result and return the fulfilled value (or null).
 */
export const recordFetch = (fetches, key, fn, params, settled) => {
  fetches.push({
    key,
    fn,
    params: params || null,
    status: settled?.status || 'unknown',
    error: settled?.status === 'rejected' ? (settled.reason?.message || String(settled.reason)) : null
  });
  return settled?.status === 'fulfilled' ? settled.value : null;
};
